import { emCompleteEventDetailsHeaders, eventHeaders, pictureDayHeaders, quarantineEventHeaders } from '../model/report-fields';
import { ReportData } from '../model/reportData';
import { saveAs } from 'file-saver';
import { ReportTableType } from '../model/reportTableType';

/**
 * For a Quarantine Event row, returns the field value combining all PIB values
 * into a single comma-separated string when multiple PIBs exist.
 */
function getQuarantineFieldValue(row: ReportData, fieldName: string): any {
  const pibDetails = row.pibDetails;
  if (pibDetails && pibDetails.length > 0) {
    if (fieldName === 'photographerId') {
      return pibDetails.map((pib) => pib.photographerId || '').join(', ');
    }
    if (fieldName === 'cameraSerialNumber') {
      return pibDetails.map((pib) => pib.cameraSerial || '').join(', ');
    }
    if (fieldName === 'numberOfOrders') {
      return pibDetails.map((pib) => pib.numberOfOrders ?? '').join(', ');
    }
  }
  return row[fieldName as keyof ReportData];
}

export function exportToCSV(reportDatas: ReportData[], reportTableType: ReportTableType) {
  let headCells = eventHeaders;
  const date = new Date();
  const month_day = date.toLocaleString('default', { month: 'short' }) + date.getDate();

  let fileName = `_${month_day}.csv`;
  if (reportTableType === 'Event') {
    fileName = 'OpenEvents' + fileName;
  } else if (reportTableType === 'Picture day') {
    fileName = 'PictureDay' + fileName;
    headCells = pictureDayHeaders;
  } else if (reportTableType === 'Not Uploaded Event') {
    fileName = 'NotUploadedEvent' + fileName;
  } else if (reportTableType === 'Quarantine Event') {
    fileName = 'QuarantineEvent' + fileName;
    headCells = quarantineEventHeaders;
  } else if (reportTableType === 'EM Completion Status') {
    fileName = 'EMCompletion' + fileName;
    headCells = emCompleteEventDetailsHeaders;
  }
  const headerTitles = headCells.map((cell) => cell.label);
  const replacer = (key: string, value: any) => (!!value ? value : '');
  const headerKeys = headCells.map((cell) => cell.id);

  const isQuarantine = reportTableType === 'Quarantine Event';

  const excelArray = reportDatas.map((row: ReportData) =>
    headerKeys
      .map((fieldName) => {
        const value = isQuarantine
          ? getQuarantineFieldValue(row, fieldName)
          : row[fieldName as keyof ReportData];
        return JSON.stringify(value, replacer);
      })
      .join(',')
  );

  excelArray.unshift(headerTitles.join(','));
  const excelString = excelArray.join('\r\n');
  const blob = new Blob([excelString], { type: 'text/csv;charset=utf-8' });
  saveAs(blob, fileName);
}
